import React from 'react';
import { Note, SizingMultiplier, Typography } from '@ocx/ui';
import { AlertCircleIcon } from '@ocx/ui-icons';

type OfferIneligibilityWarningProps = {
  message: string;
};

export const OfferIneligibilityWarning = (props: OfferIneligibilityWarningProps) => {
  const { message } = props;
  return (
    <Note
      display="flex"
      alignItems="center"
      sx={{ p: SizingMultiplier.sm, bgcolor: 'info.dark', color: 'info.contrastText' }}>
      <AlertCircleIcon color="inherit" />
      <Typography variant="body2" ml={SizingMultiplier.sm}>
        {message}
      </Typography>
    </Note>
  );
};
